export const GET_REPORTS = 'GET_REPORTS'


export const reportEnums = {
  AR_SUMMARY: "AR_SUMMARY",
  AP_SUMMARY: "AP_SUMMARY",
}